import * as React from "react";
import { EJHEALTH_COLORS, EJHEALTH_TYPE } from "@/lib/theme/ej-health";

/**
 * The row below an infinite-scroll grid: a spinner while more items remain
 * (the IntersectionObserver auto-fetches when it scrolls into view), or the
 * "all shown" message once exhausted. Pair with {@link useInfiniteList}.
 */
export function InfiniteSentinel({
  sentinelRef,
  hasMore,
  doneText,
}: {
  sentinelRef: React.RefObject<HTMLDivElement>;
  hasMore: boolean;
  doneText: string;
}) {
  return (
    <div
      ref={sentinelRef}
      className="flex h-[64px] items-center justify-center"
      aria-live="polite"
    >
      {hasMore ? (
        <span
          aria-label="載入更多"
          className="inline-block animate-spin rounded-full motion-reduce:animate-none"
          style={{
            width: 28,
            height: 28,
            border: `2px solid ${EJHEALTH_COLORS.divider}`,
            borderTopColor: EJHEALTH_COLORS.primary,
          }}
        />
      ) : (
        <span
          style={{
            ...EJHEALTH_TYPE.meta,
            color: EJHEALTH_COLORS.textMuted,
            fontSize: 13,
          }}
        >
          {doneText}
        </span>
      )}
    </div>
  );
}
